import { combineReducers } from 'redux';
import { APPREDUCER } from './App/AppReducer';
import { LOGINREDUCER } from './Auth/AuthReducer';
import { USERSREDUCER } from './Users/UsersReducer';
import { ICREDUCER } from './IC/ICReducer';
import { MISCREDUCER } from './Misc/MiscReducer';
import { CLIENTSREDUCER } from './Client/ClientsReducer';
import { BOXREDUCER } from './Box/BoxReducer';
import { SIDEMENUREDUCER } from './SideMenu/SidemenuReducer';

export default combineReducers({
  APPREDUCER,
  LOGINREDUCER,
  USERSREDUCER,
  ICREDUCER,
  MISCREDUCER,
  CLIENTSREDUCER,
  BOXREDUCER,
  SIDEMENUREDUCER
});


// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.js